export default function TrueORFalse({ question, onAnswer, selectedAnswer }) {
  return (
    <div>
      <h6 className="mb-3" style={{ fontWeight: "600", fontSize: "18px" }}>
        {question.text}
      </h6>

      <div className="row">
        {(question.choices || []).map((choice) => {
          const isSelected = selectedAnswer === choice.id;

          return (
            <div key={choice.id} className="col-md-6 mb-3">
              <label
                onClick={() => onAnswer(question.id, choice.id)}
                className={`choice-card w-100 p-3 rounded ${
                  isSelected ? "selected" : ""
                }`}
                style={{
                  border: "2px solid",
                  borderColor: isSelected ? "var(--brand-300)" : "#ccc",
                  backgroundColor: isSelected ? "#e8f6ff" : "#fff",
                  color: isSelected ? "var(--brand-300)" : "#333",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                  boxShadow: isSelected
                    ? "0 4px 12px rgba(0, 123, 255, 0.1)"
                    : "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <input
                  type="radio"
                  name={`question_${question.id}`}
                  value={choice.id}
                  checked={isSelected}
                  onChange={() => onAnswer(question.id, choice.id)}
                  style={{ display: "none" }}
                />
                {choice.text}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
